// extracted by mini-css-extract-plugin
export default {"overlay":"overlay-04ce","modal":"modal-28ea"};